import { useCallback } from 'react'
import { useMissingAudioPermissions } from '@renderer/hooks/settings/useMissingAudioPermissions'
import { useStartAudioNote } from '@renderer/hooks/useStartAudioNote'
import { useOpenViewInSidepanel } from '@renderer/overlay/hooks/use-open-view-in-sidepanel'
import { MEETING_VIEW_ID } from '@renderer/overlay/Sidepanel/components/meeting/meeting-view-id'
import { useNewMeetingContext } from '@renderer/overlay/Sidepanel/components/meeting/use-new-meeting-context'
import { AmplitudeRenderer } from '@renderer/utils/amplitude.renderer'
import { useIsMiniNotched } from '../../../atoms'

export function useStartMiniMeeting(): () => void {
  const isNotched = useIsMiniNotched()
  const { startAudioNote } = useStartAudioNote()
  const { isLoaded: audioPermissionsLoaded, nextPermission } = useMissingAudioPermissions()
  const { openViewInSidepanel } = useOpenViewInSidepanel()
  const newMeeting = useNewMeetingContext()

  return useCallback(() => {
    AmplitudeRenderer.trackEvent('Audio Note Action', {
      action: 'start taking notes',
      source: isNotched ? 'notch' : 'mini',
    })
    startAudioNote({
      source: 'assistant',
      onSuccessfulStart: () => {
        if (!isNotched || (audioPermissionsLoaded && nextPermission === null)) {
          openViewInSidepanel(MEETING_VIEW_ID, newMeeting)
        }
      },
    })
  }, [startAudioNote, isNotched, audioPermissionsLoaded, nextPermission, openViewInSidepanel, newMeeting])
}
